import React, { Component } from "react";
import { Tag } from "antd";

export const BULK_UPLOAD_COLUMNS = [
    {
        title: 'Upload Type',
        dataIndex: 'upload_type',
        key: 'upload_type',
        width: '10%'
    },
    {
        title: 'File Name',
        dataIndex: 'name',
        key: 'name',
        width: '10%',
        render: (text) => (
            <div style={{
                whiteSpace: 'normal',
                wordBreak: 'break-all',
                fontSize: 12,
                lineHeight: 1.2,
                maxWidth: 120,
                overflowWrap: 'break-word',
                padding: 0,
                margin: 0
            }}>{text}</div>
        )
    },
    {
        title: 'Uploaded By',
        dataIndex: 'uploaded_by',
        key: 'uploaded_by',
        width: '10%'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: '5%',
        render: (_, { status }) => {
            let backgroundColor, textColor;
            switch (status) {
                case 'Upload completed':
                    backgroundColor = '#D2FFEA'; // Light green
                    textColor = '#00763D'; // Darker green
                    break;
                case 'Processing':
                    backgroundColor = '#D0E8FF'; // Light blue
                    textColor = '#1E90FF'; // Darker blue
                    break;
                case 'Failed upload':
                    backgroundColor = '#FFEAEA'; // Light red
                    textColor = '#B80100'; // Darker red
                    break;
                case 'Partially uploaded':
                    backgroundColor = '#FFEDDD'; // Light orange
                    textColor = '#FF8D24'; // Darker orange
                    break;
                default:
                    backgroundColor = '#E8E8E8'; // Light gray
                    textColor = '#696969'; // Dark gray
            }
            return (
                <Tag style={{ backgroundColor, color: textColor, fontWeight: 'bold', border: 'none' }}>
                    {status}
                </Tag>
            );
        }
    },
    {
        title: 'Total Records',
        dataIndex: 'total',
        key: 'total',
        width: '10%'
    },
    {
        title: 'Success',
        dataIndex: 'success',
        key: 'success',
        width: '10%'
    },
    {
        title: 'Failure',
        dataIndex: 'failure',
        key: 'failure',
        width: '10%',
        render: (text) => (
            Number(text) > 0
                ? <span style={{ color: 'red', fontWeight: 'bold' }}>{text}</span>
                : <span>{text}</span>
        )
    },
    {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        width: '10%'
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        width: '10%'
    }
];